import React, { useEffect, useState } from 'react';
import { AuthApplicationLogo, Input } from 'hmi';
import { isEmail } from '../../utils/Validations';
import { useSelector } from 'react-redux';
import { selectParentApp } from '../hmi/hmiSlice';
import { getParameterByName } from '../../utils/WindowHelper';
import { lookupLogin } from '../../api/hattersAPI';
import { buildRequestURL } from '../../utils/utils';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';
import FormatMessage from '../messages/FormatMessage';
import { selectMessages } from '../messages/messagesSlice';
import { Link } from 'react-router-dom';

type Props = {
  setUserNotVerified: (email: string) => void;
};

export const LoginEmail: React.FC<Props> = ({ setUserNotVerified }) => {
  const parentApp = useSelector(selectParentApp);
  const messages = useSelector(selectMessages);
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorSuggestion, setErrorSuggestion] = useState('');

  const isSandbox = () => {
    return !parentApp?.info.published || false;
  };

  const lookUpEmail = async () => {
    try {
      const res = await lookupLogin(email, isSandbox());

      if (res.parsedBody) {
        const { hatCluster, hatName, verified } = res.parsedBody;

        if (hatName && hatCluster) {
          const nextStepLink = buildURLQueryParams(`https://${hatName}.${hatCluster}/auth/oauth`);

          if (verified) {
            window.location.href = nextStepLink;
          } else {
            setUserNotVerified(email);
          }
        }
      }
    } catch (err) {
      setErrorMessage(messages['hatters.auth.login.notRecognized']);
      setErrorSuggestion('');
    }
  };

  const buildURLQueryParams = (url: string) => {
    const applicationId = getParameterByName('application_id');
    const redirectUri = getParameterByName('redirect_uri');
    const lang = getParameterByName('lang') || 'en';

    let params: { [key: string]: string } = {};

    if (lang) {
      params['lang'] = lang;
    }

    if (email) {
      params['email'] = email;
    }

    if (applicationId) {
      params['application_id'] = applicationId;
    }

    if (redirectUri) {
      params['redirect_uri'] = redirectUri;
    }

    return buildRequestURL(url, params);
  };

  useEffect(() => {
    setErrorMessage('');
  }, [email]);

  const onClickNext = () => {
    if (isEmail(email)) {
      lookUpEmail();
    } else {
      if (messages) {
        setErrorMessage(messages['hatters.auth.login.notValidUsername']);
        setErrorSuggestion(messages['hatters.auth.login.notValidUsernameSuggestion']);
      }
    }
  };

  useEffect(() => {
    const email = getParameterByName('email');

    if (email && isEmail(email)) {
      setEmail(email);
    }
  }, []);

  if (!parentApp) return <LoadingScreen messageId={'hatters.signup.loading'} />;

  return (
    <>
      <div className={'flex-column-wrapper login'}>
        <AuthApplicationLogo src={parentApp?.info.graphics.logo.normal} alt={parentApp?.info.name} />
        <h2 className={'login-title'}>
          <FormatMessage id={'hatters.auth.login.title'} asHtml />
        </h2>
        <Input
          type={'email'}
          placeholder={'Email'}
          autoComplete={'email'}
          id={'email'}
          value={email}
          hasError={!!errorMessage}
          errorMessage={errorMessage}
          errorSuggestion={errorSuggestion}
          autoCapitalize={'none'}
          onChange={(e) => setEmail(e.target.value)}
          spellCheck="false"
          autoCorrect="off"
        />

        <button
          className={'login-btn ds-hmi-btn ds-hmi-btn-primary'}
          disabled={email.length < 3}
          onClick={() => onClickNext()}
        >
          <FormatMessage id={'hatters.auth.nextBtn'} />
        </button>

        <hr />

        <p className={'login-have-an-account'}>
          <FormatMessage id={'hatters.auth.login.dontHaveAnAccount'} />
        </p>

        <Link className={'login-btn-signup ds-hmi-btn'} to={buildURLQueryParams('/services/signup')}>
          <FormatMessage id={'hatters.auth.signupBtn'} />
        </Link>
      </div>
    </>
  );
};
